<div class="kortvisning">
  <dokument-kortvisning [dokumentversjon]="dokumentversjon()" (vedAapneInline)="aapneInline()" bredde="180px" hoeyde="200px"/>
  <div class="tittel">
    <h3>{{ informasjon().standardnavn }}</h3>
    @if (redigerbar()) {
      <button mat-icon-button
              [matMenuTriggerFor]="dokumentMeny.matMeny()"
              (click)="$event.stopPropagation()"
              class="mat-medium-icon-button meny">
        <mat-icon class="material-symbols-fet">more_vert</mat-icon>
      </button>
      <dokument-meny [dokumentversjon]="dokumentversjon()" [signatarinformasjon]="signaturinformasjon()" #dokumentMeny/>
    }
  </div>
</div>

<tittel-verdi tittel="Informasjon" stil="vertikal--med-linje" class="informasjon">
  <verdi>
    <tittel-verdi-samling stil="tabell">
      <tittel-verdi tittel="{{'Versjon'|translate}}">
        <verdi>
          <mat-icon inline="true" fontSet="lederplan-ikon-versjoner" class="mat-icon--lederplan-ikon"/>
          {{ dokumentversjon().versjonsnummer }}
        </verdi>
      </tittel-verdi>
      <tittel-verdi tittel="{{'Kommentarer'|translate}}">
        <verdi>
          <mat-icon inline="true" fontSet="lederplan-ikon-pencil-marker" class="mat-icon--lederplan-ikon"/>
          {{ dokumentversjon().antallAnnotasjoner }}
        </verdi>
      </tittel-verdi>
      <tittel-verdi tittel="{{'Antall sider'|translate}}">
        <verdi>
          @if (dokumentversjon().antallSider ?? 0 > 0) {
            <mat-icon inline="true" fontSet="lederplan-ikon-aapenbok" class="mat-icon--lederplan-ikon"/>
            {{ dokumentversjon().antallSider }}
          } @else {
            {{ 'ukjent'|translate }}
          }
        </verdi>
      </tittel-verdi>
      <tittel-verdi tittel="{{'Registrert'|translate}}">
        <verdi>{{ dokumentversjon().registreringsdato|zoneddatetimeSomPlaindate|plaindate }} {{ dokumentversjon().registrertAv?.navn }}</verdi>
      </tittel-verdi>
      <tittel-verdi tittel="{{'Størrelse'|translate}}">
        <verdi>{{ dokumentversjon().filstoerrelse|filstoerrelse }}</verdi>
      </tittel-verdi>
      <tittel-verdi tittel="{{'Formater'|translate}}">
        <verdi class="formater">
          @for (format of informasjon().formater; track format.mimeinfo.mimetype) {
            <span (click)="aapneFormat(format)" [matTooltip]="'Åpne dokumentet i {format}-format'|translate: {format: format.mimeinfo.visningsnavn}">
              <dokument-format-ikon [mimeinfo]="format.mimeinfo"/>
              {{ format.mimeinfo.visningsnavn }}
            </span>
          }
        </verdi>
      </tittel-verdi>
    </tittel-verdi-samling>
  </verdi>
</tittel-verdi>

<tittel-verdi tittel="{{'Signering'|translate}}" stil="vertikal--med-linje" class="signering" data-testid="signering" #signeringBlokk>
  <verdi>
    @if (sendTilSigneringMulig()) {
      <!-- bruker har redigeringstilgang og dokument er ikke sendt til signering -->
      <tips>{{ 'Inviter medlemmer til å signere dokumentet elektronisk med BankID eller engangskode'|translate }}</tips>
      <button mat-button color="primary" (click)="sendTilSignering()">
        {{ 'Send til signering'|translate }}
      </button>
    } @else if (dokumentversjon().signeringStatus == signeringsstatuser.ikkeAktivert) {
      <!-- bruker har ikke redigeringstilgang dokument er ikke sendt til signering -->
      <p>{{ 'Signering er ikke aktivert'|translate }}</p>
    } @else {
      <!-- dokument er sendt til signering -->
      <dokument-til-signering-status [dokumentversjon]="dokumentversjon()"/>
    }
  </verdi>
</tittel-verdi>

<!--<tittel-verdi tittel="Protokollbehandling" stil="vertikal--med-linje" class="protokollbehandling">
  <verdi>
    Dette er protokoll for Styremøte 2-3, 23.mars 2003
    Gå til møte
  </verdi>
</tittel-verdi>-->

@if (erArkivdokument()) {
  <tittel-verdi tittel="{{'Behandles i'|translate}}" stil="vertikal--med-linje" class="behandlinger" #sakerArkivdokumentBehandlesIBlokk>
    <verdi>
      @if (sakerArkivdokumentetBehandlesI().length > 0) {
        <p>{{ 'Behandles i følgende saker:'|translate }}</p>
        <ul>
          @for (behandling of sakerArkivdokumentetBehandlesI(); track behandling.dokumentVersjon.id) {
            @for (sak of behandling.tilknyttedeSaker; track sak.id) {
              <li [matTooltip]="'Gå til sak i møtet avholdt {dato}'|translate: {dato:sak.moete.dato.start|zoneddatetime}">
                <a (click)="gaaTilBehandling(sak)">
                  <span class="tittel">
                    {{ 'Sak {saksnummer} - {sakstittel} i {moetetittel} {moetenummer}'|translate: {saksnummer: sak.nummer, sakstittel: sak.tittel, moetetittel: sak.moete.tittel, moetenummer: sak.moete.nummer} }}
                  </span>
                  @if (harMultipleVersjoner()) {
                    <span class="versjon">(ver.{{ behandling.dokumentVersjon.versjonsnummer }})</span>
                  }
                  <mat-icon inline="true">arrow_forward</mat-icon>
                </a>
              </li>
            }
          }
        </ul>
      } @else {
        <p>{{ 'Ikke til behandling i noen sak'|translate }}</p>
        @if (redigerbar()) {
          <tips>{{ "Arkivdokumenter kan enkelt legges til i en sak via 'legg til dokument'-dialogen på den aktuelle saken"|translate }}</tips>
        }
      }
    </verdi>
  </tittel-verdi>
}

<tittel-verdi tittel="{{'Versjoner'|translate}}" stil="vertikal--med-linje" class="versjoner" #versjonerBlokk>
  <verdi>
    @if (harMultipleVersjoner()) {
      <div class="listing">
        <!-- normalt vises dokument i 160*200, litt mindre her for å få plass til to i bredden-->
        <dokumentversjon-liste [dokumentId]="dokumentversjon().dokumentId" dokumentBredde="115px" dokumentHoeyde="140px"/>
      </div>
    } @else {
      <p>{{ 'Ingen flere versjoner'|translate }}</p>
      @if (redigerbar()) {
        <tips>{{ 'Hold rede på historikken ved å registrere ny versjon av et dokument fremfor å slette og laste opp på nytt'|translate }}</tips>
      }
    }
    @if (redigerbar()) {
      <div class="handlinger">
        <button mat-button color="primary" (click)="registrerNyVersjon()" matTooltip="{{'Klikk for å velge fil for opplasting fra datamaskinen din'|translate}}">
          {{ 'Registrer ny versjon'|translate }}
        </button>
      </div>
    }
  </verdi>
</tittel-verdi>

<tittel-verdi tittel="{{'Tilgang'|translate}}" stil="vertikal--med-linje" class="skjerming" #skjermingBlokk>
  <verdi>
    @if (dokumentversjon().skjerming.skjermedeMedlemmerId.length > 0) {
      <skjerming-vis [skjerming]="skjerming()" [type]="skjermetEntitetType()!"/>
    } @else {
      <p>{{ 'Alle medlemmer kan lese dette dokumentet'|translate }}</p>
    }
    @if (redigerbar()) {
      <div class="handlinger">
        <button mat-button color="primary" (click)="redigerSkjerming()" matTooltip="{{'...'|translate}}">
          {{ 'Rediger tilgang'|translate }}
        </button>
      </div>
    }
  </verdi>
</tittel-verdi>


<!--
<div class="versjoner">
  <h3>Versjoner</h3>
  @if (harMultipleVersjoner()){
    <button mat-button color="primary" (click)="visVersjoner()">
      {{'Vis {antall} andre versjoner'|translate: {antall: dokumentversjon().versjonsnummer -1} }}
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>
  } @else {
    Det finnes ingen andre versjoner av dette dokumentet.
  }

  @for (versjon of versjoner(); track versjon.id) {
    <div class="versjon">
      <span>{{ versjon.filnavn }}</span>
      <span>{{ versjon.versjonsnummer }}</span>
    </div>
  }
</div>

<div class="tilgang">
  <h3>Tilgang</h3>

  @if (dokumentversjon().skjerming.skjermedeMedlemmerId.length > 0) {
    <button mat-button color="primary" (click)="visSkjerming()">
      {{'Vis {antall} medlemmer uten tilgang'|translate: {antall:dokumentversjon().skjerming.skjermedeMedlemmerId.length} }}
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>
  } @else {
    Alle medlemmer kan se dette dokumentet.
  }

  @for (medlem of skjeming().skjermedeMedlemmer; track medlem.id) {
    <medlem-listevisning-kompakt [medlem]="medlem"/>
  }
</div>

<div class="signer">
  <h3>Signering</h3>
  <dokument-til-signering-status [dokumentversjon]="dokumentversjon()"/>

  <h3>Handlinger</h3>
  @if (dokumentversjon().signeringStatus == signeringsstatuser.ikkeAktivert){
    <button mat-stroked-button (click)="visVersjoner()">
      {{'Send dokument til signering'|translate}}
    </button>
  }


</div>-->
